import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { CarriagesService } from '../../../services/carriages.service';

@Component({
    selector: 'app-upload-carriages',
    templateUrl: './upload-carriages.component.html',
    styleUrls: ['./upload-carriages.component.scss'],
})
export class UploadCarriagesComponent implements OnInit, OnDestroy {
    private fb = inject(FormBuilder);
    public modal = inject(DynamicDialogRef);
    private service = inject(CarriagesService);

    public startedUpload = false;
    public error = null;
    public isBusy = false;
    public form: FormGroup;
    private destroy$ = new Subject<void>();

    ngOnInit() {
        this.form = this.fb.group({
            carriages_file: [null, [Validators.required]],
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    startUpload() {
        this.form.markAllAsTouched();

        if (this.form.invalid) {
            return;
        }
        this.isBusy = true;
        this.error = null;
        this.service
            .startCarriagesUpload(this.form.value)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: () => {
                    this.isBusy = false;
                    this.startedUpload = true;
                },
                error: error => {
                    this.isBusy = false;
                    this.error = error;
                },
            });
    }

    handleFileUpload(event: { file }) {
        this.form.get('carriages_file')?.markAsTouched();
        this.form.get('carriages_file')?.setValue(event.file, {
            emitEvent: true,
            emitModelToViewChange: true,
            emitViewToModelChange: true,
        });
    }
}
